export const gstConstants = {
  GET_SINGLE_REQUEST: "GST_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "GST_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "GST_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "GST_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "GST_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "GST_GET_ALL_FAILURE",

  ADD_REQUEST: "GST_ADD_REQUEST",
  ADD_SUCCESS: "GST_ADD_SUCCESS",
  ADD_FAILURE: "GST_ADD_FAILURE",

  UPDATE_REQUEST: "GST_UPDATE_REQUEST",
  UPDATE_SUCCESS: "GST_UPDATE_SUCCESS",
  UPDATE_FAILURE: "GST_UPDATE_FAILURE",

  DELETE_REQUEST: "GST_DELETE_REQUEST",
  DELETE_SUCCESS: "GST_DELETE_SUCCESS",
  DELETE_FAILURE: "GST_DELETE_FAILURE",

  CLEAR: "GST_CLEAR",
};
